/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Token_InvalidInputs */

const cs_auth_reset_token_invalid = /** @type {(inputs: Auth_Reset_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz pro obnovení hesla je neplatný nebo vypršel. Požádejte o nový.`)
};

const en_auth_reset_token_invalid = /** @type {(inputs: Auth_Reset_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This reset link is invalid or has expired. Request a new one.`)
};

/**
* | output |
* | --- |
* | "This reset link is invalid or has expired. Request a new one." |
*
* @param {Auth_Reset_Token_InvalidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_token_invalid = /** @type {((inputs?: Auth_Reset_Token_InvalidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Token_InvalidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_token_invalid(inputs)
	return cs_auth_reset_token_invalid(inputs)
});